import { useEffect, useRef } from "react";
import { restoreReportStateThunk, storeReportStateThunk, } from "../../store/report";
import { useReportDispatch, useReportSelector } from "./index";
/**
 * useRestoreReportSlices - hook to restore and save current report object from state.
 * @param reportId - string to use as key for restoring/storing report state.
 * @param latestReportId - latest report id for matching against stored state to determine whether to restore state
 *                        or not. Necessary to avoid issues with state being out of date due to reanalyze.
 */
const useRestoreReportSlices = (reportId, latestReportId) => {
    const dispatch = useReportDispatch();
    const report = useReportSelector((state) => state.report);
    const hydratedFor = useRef(null);
    useEffect(() => {
        if (!reportId || !latestReportId) {
            return;
        }
        const hydrationKey = `${reportId}::${latestReportId}`;
        if (hydratedFor.current === hydrationKey) {
            return;
        }
        hydratedFor.current = hydrationKey;
        dispatch(restoreReportStateThunk(reportId, latestReportId));
    }, [reportId, latestReportId, dispatch]);
    useEffect(() => {
        dispatch(storeReportStateThunk(reportId, latestReportId));
    }, [reportId, latestReportId, report, dispatch]);
};
export default useRestoreReportSlices;
//# sourceMappingURL=useRestoreReportSlices.js.map